export const DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const MONTH = [
  { mmm: 'JAN', value: 0 },
  { mmm: 'FEB', value: 1 },
  { mmm: 'MAR', value: 2 },
  { mmm: 'APR', value: 3 },
  { mmm: 'MAY', value: 4 },
  { mmm: 'JUN', value: 5 },
  { mmm: 'JUL', value: 6 },
  { mmm: 'AUG', value: 7 },
  { mmm: 'SEP', value: 8 },
  { mmm: 'OCT', value: 9 },
  { mmm: 'NOV', value: 10 },
  { mmm: 'DEC', value: 11 },
];

export const YEAR = [2023, 2024, 2025, 2026, 2027, 2028];
